<script>
import store from '@/lib/store'

export default {
  beforeRouteEnter (to, from, next) {
    store.truncate()

    next('/login')
  }
}
</script>



// WEBPACK FOOTER //
// Logout.vue?8d2399b6